export default __webpack_public_path__ + "assets/images/resin_85478e9b83f89fa7c17935de9c16b5a8.jpg";